import { CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";
import { inject } from "@angular/core";
import { catchError, filter, first, map } from "rxjs/operators";
import { Observable, of } from "rxjs";
import { AuthService } from "./shared/services/auth/auth.service";
import { MessageService } from "primeng/api";

export const authGuard: CanActivateFn = (route, state: RouterStateSnapshot): Observable<boolean> => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const messageService = inject(MessageService);

  return authService.checkAuth().pipe(
    filter((isAuth): isAuth is boolean => isAuth !== null),
    first(),
    map(isAuth => {
      console.log(isAuth);
      if (isAuth) {
        return true;
      } else {
        console.log("[AuthGuard] User is not authenticated. Redirecting to login page.");
        authService.setRedirectUrl(state.url);
        router.navigate(["/login"]).then(() => {
          messageService.add({
            severity: "warn",
            summary: "Błąd uwierzytelniania",
            detail: "Zaloguj się ponownie.",
            life: 15000,
          });
        });
        return false;
      }
    }),
    catchError((err) => {
      console.error("[AuthGuard] Error checking authentication status:", err);
      authService.setRedirectUrl(state.url);
      router.navigate(["/login"]).then();
      return of(false);
    }),
  );
};
